export default {
    SET_APPOINTMENT: 'SET_APPOINTMENT',
    SET_WEB_CONFIG: 'SET_WEB_CONFIG',
    SET_APP_PROMPT_CLOSE: 'SET_APP_PROMPT_CLOSE',
    SET_LANGUAGE_SELECTION: 'SET_LANGUAGE_SELECTION',
    SET_FIREBASE_REMOTE_CONFIGS: 'SET_FIREBASE_REMOTE_CONFIGS',
    SET_DELETE_ACC_REQUEST: 'SET_DELETE_ACC_REQUEST',
    SET_DOCTORS: 'SET_DOCTORS',
};
